module.exports = __webpack_public_path__ + "img/news-next.5fd0a778.svg";